<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="订单编号/客户简称/搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-allow="'actExport'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('batchExport')"
            >
              <i class="el-icon-download"></i>
              导出
            </b-button>
            <b-button
              v-allow="'actExport'"
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="accountDialogVisible = true"
            >
              <i class="el-icon-plus"></i>
              生成台账
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      title="请选择生成台账时间段"
      :show-close="true"
      :visible.sync="accountDialogVisible"
      v-el-dialog-drag
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="eldialog-stye">
        <el-form ref="accountFrom" :rules="rules" :model="accountFrom">
          <el-row>
            <el-col :span="24">
              <el-form-item label="开始日期" prop="beginDate">
                <el-date-picker
                  v-model="accountFrom.beginDate"
                  type="date"
                  size="small"
                  :picker-options="dateStartPicker"
                  value-format="yyyy-MM-dd"
                  placeholder="选择开始日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="结束日期" prop="endDate">
                <el-date-picker
                  v-model="accountFrom.endDate"
                  type="date"
                  size="small"
                  :picker-options="dateEndPicker"
                  value-format="yyyy-MM-dd"
                  placeholder="选择结束日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="accountDialogVisible = false"
          >取消</el-button
        >
        <el-button size="small" type="primary" @click="generateBill"
          >确认生成</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="订单编号">
              <el-input
                v-model.trim="form.orderNo"
                placeholder="请输入订单编号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="客户名称">
              <dict-select
                filterable
                style="width:100%"
                v-model="form.custCode"
                url="/master/customer/info/select"
                placeholder="请选择客户"
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="总件数">
              <el-input-number
                style="width:100%"
                clearable
                v-model="form.goodsQty"
                :step="1"
                :precision="0"
                :min="0"
                controls-position="right"
                placeholder="请选择总件数"
                size="small"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="发货地址">
              <el-input
                v-model.trim="form.originPlace"
                placeholder="请输入发货地址"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="收货地址">
              <el-input
                v-model.trim="form.destinationPlace"
                placeholder="请输入收货地址"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="车辆总数量">
              <el-input-number
                clearable
                v-model="form.vehicleTotalQty"
                placeholder="请输入车辆总数量"
                controls-position="right"
                style="width:100%"
                :max="999999"
                :min="0"
                :step-strictly="true"
                :step="1"
              >
              </el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="生成时间">
              <el-date-picker
                v-model="form.beginDate"
                type="date"
                size="small"
                :picker-options="genDateStartPicker"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="到">
              <el-date-picker
                v-model="form.endDate"
                type="date"
                size="small"
                :picker-options="genDateEndPicker"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from "@/libs/util.validate"

// 初始表单
const initForm = {
  keyword: "",
  settlementStatusList: ["Y", "N"],
}

export default {
  data() {
    return {
      accountDialogVisible: false,
      advqueryDialogVisible: false,
      accountFrom: {},
      form: { ...initForm },
      genDateStartPicker: this.genDateEnd(),
      genDateEndPicker: this.genDateStart(),
      dateStartPicker: this.dateEnd(),
      dateEndPicker: this.dateStart(),
      rules: {
        beginDate: [
          {
            required: true,
            message: "请选择开始日期",
            trigger: "blur",
          },
        ],
        endDate: [
          {
            required: true,
            message: "请选择结束日期",
            trigger: "blur",
          },
        ],
      },
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    async generateBill() {
      const result = await validate.formValidate([this.$refs.accountFrom])
      if (!result) return
      let _this = this
      this.$confirm("确定生成会计账单？", "确认信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      }).then(() => {
        this.$api
          .finAccountBookBuilder({ ...this.accountFrom })
          .then((res) => {
            const { status } = res
            if (status === 200) {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "success",
              })
              _this.accountDialogVisible = false
              this.query()
            }
          })
          .catch(() => {})
      })
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit("reset")
      }
      this.$emit("query", this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ""
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    genDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endDate).getTime() < time.getTime()
          }
        },
      }
    },
    genDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    //时间限制
    dateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.accountFrom.endDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.accountFrom.endDate).getTime() < time.getTime()
          }
        },
      }
    },
    dateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.accountFrom.beginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.accountFrom.beginDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.eldialog-stye {
  margin-top: 14px;
}
.mt-2p {
  margin-top: 2px;
}
.line {
  text-align: center;
}
</style>
